import { NavigationEnd, Router } from '@angular/router';
import { RememberStateService } from '@common/services/remember-state.service';
import { UserService } from '@common/services/user.service';
import { NAVIGATION } from 'app/navigation';
import * as _ from 'lodash';
import { filter, first } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@common/services/remember-state.service";
import * as i3 from "@common/services/user.service";
import * as i4 from "@angular/common";
import * as i5 from "@fortawesome/angular-fontawesome";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "@ngx-translate/core";
function SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", item_r1.icon);
  }
}
function SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 13);
  }
}
function SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 14);
  }
}
function SidebarComponent_ng_template_1_ul_0_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function SidebarComponent_ng_template_1_ul_0_a_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const item_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.selectItem(item_r1));
    });
    i0.ɵɵtemplate(1, SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_1_Template, 1, 1, "fa-icon", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtemplate(5, SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_5_Template, 1, 0, "fa-icon", 10);
    i0.ɵɵtemplate(6, SidebarComponent_ng_template_1_ul_0_a_2_fa_icon_6_Template, 1, 0, "fa-icon", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(3, 4, item_r1.title), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r1 !== ctx_r3.selectedItem);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1 === ctx_r3.selectedItem);
  }
}
function SidebarComponent_ng_template_1_ul_0_a_3_fa_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", item_r1.icon);
  }
}
function SidebarComponent_ng_template_1_ul_0_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function SidebarComponent_ng_template_1_ul_0_a_3_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const item_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.selectItem(item_r1));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, SidebarComponent_ng_template_1_ul_0_a_3_fa_icon_2_Template, 1, 1, "fa-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("ngbTooltip", i0.ɵɵpipeBind1(1, 2, item_r1.title));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r1.icon);
  }
}
function SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_1_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const child_r20 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", child_r20.icon);
  }
}
function SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵtemplate(1, SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_1_fa_icon_1_Template, 1, 1, "fa-icon", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r20 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("routerLink", child_r20.route);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", child_r20.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(3, 3, child_r20.title), " ");
  }
}
function SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_2_fa_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const child_r20 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", child_r20.icon);
  }
}
function SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_2_fa_icon_2_Template, 1, 1, "fa-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r20 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("routerLink", child_r20.route);
    i0.ɵɵpropertyInterpolate("ngbTooltip", i0.ɵɵpipeBind1(1, 3, child_r20.title));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", child_r20.icon);
  }
}
const _c0 = function (a0, a1) {
  return {
    active: a0,
    "align-with-group": a1
  };
};
function SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵtemplate(1, SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_1_Template, 4, 5, "a", 18);
    i0.ɵɵtemplate(2, SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_a_2_Template, 3, 5, "a", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0, ctx_r21.isActive(child_r20.route), ctx_r21.isCollapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r21.isCollapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.isCollapsed);
  }
}
function SidebarComponent_ng_template_1_ul_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SidebarComponent_ng_template_1_ul_0_ng_template_5_li_0_Template, 3, 6, "li", 16);
  }
  if (rf & 2) {
    const child_r20 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", child_r20.hasPermission);
  }
}
const _c1 = function (a0) {
  return {
    active: a0
  };
};
function SidebarComponent_ng_template_1_ul_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3)(1, "li");
    i0.ɵɵtemplate(2, SidebarComponent_ng_template_1_ul_0_a_2_Template, 7, 6, "a", 4);
    i0.ɵɵtemplate(3, SidebarComponent_ng_template_1_ul_0_a_3_Template, 3, 4, "a", 5);
    i0.ɵɵelementStart(4, "ul", 6);
    i0.ɵɵtemplate(5, SidebarComponent_ng_template_1_ul_0_ng_template_5_Template, 1, 1, "ng-template", 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx_r2.selectedItem === item_r1 || ctx_r2.isActive(item_r1.route)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isCollapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isCollapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", ctx_r2.selectedItem !== item_r1 && !ctx_r2.isActive(item_r1.route));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r1.children);
  }
}
function SidebarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SidebarComponent_ng_template_1_ul_0_Template, 6, 7, "ul", 2);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r1.hasPermission);
  }
}
const _c2 = function (a0) {
  return {
    width: a0
  };
};
export class SidebarComponent {
  constructor(router, rememberStateService, userService) {
    this.router = router;
    this.rememberStateService = rememberStateService;
    this.navigation = NAVIGATION;
    this.selectedItem = this.navigation[0];
    userService.currentUserSubject.subscribe(user => {
      this.user = user;
      this.setPermissions();
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) this.url = this.router.url;
    });
    this.router.events.pipe(filter(x => x instanceof NavigationEnd), first()).subscribe(event => {
      const item = _.find(this.navigation.filter(x => x.route === this.router.url || _.find(x.children, c => this.router.url.indexOf(c.route) === 0)));
      if (item) this.selectedItem = item;
    });
  }
  ngOnInit() {
    this.isCollapsed = this.rememberStateService.initialize('sidebar');
  }
  isActive(route) {
    return this.url && (this.url === route || this.url.includes(route));
  }
  selectItem(item) {
    if (item.route) {
      this.router.navigate([item.route]);
      return this.selectedItem = null;
    }
    if (this.selectedItem === item) {
      return this.selectedItem = null;
    }
    this.selectedItem = item;
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.rememberStateService.setState('sidebar', this.isCollapsed);
  }
  setPermissions() {
    _.forEach(this.navigation, x => this.setMenuItemPermission(x));
  }
  setMenuItemPermission(menuItem) {
    menuItem.hasPermission = this.hasPermission(menuItem);
    _.forEach(menuItem.children, y => this.setMenuItemPermission(y));
  }
  hasPermission(menuItem) {
    if (!this.user) return false;
    const permissions = _.isArray(menuItem.permissions) ? menuItem.permissions : menuItem.permissions ? [menuItem.permissions] : [];
    if (!menuItem.permissions || _.isArray(menuItem.permissions) && menuItem.permissions.length === 0) {
      return true;
    }
    return this.user.hasPermission(...permissions);
  }
}
SidebarComponent.ɵfac = function SidebarComponent_Factory(t) {
  return new (t || SidebarComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.RememberStateService), i0.ɵɵdirectiveInject(i3.UserService));
};
SidebarComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: SidebarComponent,
  selectors: [["app-sidebar"]],
  decls: 2,
  vars: 4,
  consts: [[1, "bg-dark", "sidebar", "overflow-auto", 3, "ngStyle"], ["ngFor", "", 3, "ngForOf"], ["class", "nav nav-pills flex-column", 3, "ngClass", 4, "ngIf"], [1, "nav", "nav-pills", "flex-column", 3, "ngClass"], ["class", "nav-link", "href", "javascript:void(0)", "style", "display: block", 3, "click", 4, "ngIf"], ["class", "nav-link", "href", "javascript:void(0)", "style", "display: block", "placement", "right", "container", "body", 3, "ngbTooltip", "click", 4, "ngIf"], [1, "nav", "nav-pills", "flex-column", 3, "hidden"], ["href", "javascript:void(0)", 1, "nav-link", 2, "display", "block", 3, "click"], [3, "icon", 4, "ngIf"], [1, "float-right", "text-muted"], ["icon", "caret-down", 4, "ngIf"], ["icon", "caret-up", 4, "ngIf"], [3, "icon"], ["icon", "caret-down"], ["icon", "caret-up"], ["href", "javascript:void(0)", "placement", "right", "container", "body", 1, "nav-link", 2, "display", "block", 3, "ngbTooltip", "click"], ["class", "nav-item", 3, "ngClass", 4, "ngIf"], [1, "nav-item", 3, "ngClass"], ["class", "nav-link", 3, "routerLink", 4, "ngIf"], ["class", "nav-link", "placement", "right", "container", "body", 3, "routerLink", "ngbTooltip", 4, "ngIf"], [1, "nav-link", 3, "routerLink"], ["placement", "right", "container", "body", 1, "nav-link", 3, "routerLink", "ngbTooltip"]],
  template: function SidebarComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "nav", 0);
      i0.ɵɵtemplate(1, SidebarComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c2, ctx.isCollapsed ? "60px" : "250px"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngForOf", ctx.navigation);
    }
  },
  dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgStyle, i1.RouterLink, i5.FaIconComponent, i6.NgbTooltip, i7.TranslatePipe],
  styles: [".sidebar[_ngcontent-%COMP%] {\n  width: 250px;\n  flex: 0;\n  font-size: 14px;\n  position: fixed;\n  top: 45px;\n  bottom: 0;\n  left: 0;\n  z-index: 900;\n  \n  overflow-x: hidden;\n  overflow-y: auto;\n  white-space: nowrap;\n  overflow: hidden;\n  box-shadow: 2px 0 10px 0 rgba(0, 0, 0, 0.65);\n  transition: width 0.3s linear;\n}\n\n.title[_ngcontent-%COMP%] {\n  color: #4b646f;\n  display: inline-block;\n  font-size: 12px;\n  padding: 0.75rem 1rem;\n}\n\nfa-icon[_ngcontent-%COMP%] {\n  width: 20px;\n  text-align: center;\n  display: inline-block;\n}\n\na[_ngcontent-%COMP%] {\n  padding: 0.75rem 1rem;\n}\n\nul.active[_ngcontent-%COMP%] {\n  background-color: #2c3b41;\n}\n\n.sidebar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  color: #b8c7ce;\n}\n.sidebar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover {\n  color: #fff;\n}\n.sidebar[_ngcontent-%COMP%]    > ul[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  border-left: 3px solid #292b2c;\n}\n.sidebar[_ngcontent-%COMP%]    > ul[_ngcontent-%COMP%]    > li.header[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]    > ul[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] {\n  background: #2c3b41;\n}\n.sidebar[_ngcontent-%COMP%]    > ul[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]:hover, .sidebar[_ngcontent-%COMP%]    > ul.active[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n  border-left: 3px solid #2196f3;\n  color: #fff;\n}\n.sidebar[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  padding-left: 24px;\n  transition: padding-left 0.25s;\n}\n.sidebar[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.align-with-group[_ngcontent-%COMP%] {\n  padding-left: 3px;\n}\n.sidebar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.sidebar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]    + .nav-item[_ngcontent-%COMP%] {\n  margin-left: 0;\n}\n.sidebar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]:hover {\n  background-color: rgba(2, 117, 216, 0.7);\n}\n.sidebar[_ngcontent-%COMP%]   .nav-item.active[_ngcontent-%COMP%] {\n  background-color: rgba(2, 117, 216, 0.7);\n}\n.sidebar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:hover {\n  color: #fff;\n}\n.sidebar[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%] {\n  border-radius: 0;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
});